import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetProductAssetsReport'
import Component from 'components/Reports/AssetProductAssetsReport'

export default createListViewContainer({ actions, selectors: selectors.assetProductAssetsReport })(Component)
